<div id="input-container">
  <input
    type="text"
    #valueInput
    [id]="formControlName"
    appNumberOnly
    decimals="{{ decimals }}"
    [(ngModel)]="stringValue"
    class="form-control"
    [disabled]="disabled"
    [class.disabled]="disabled"
    aria-placeholder="0"
    [attr.aria-labelledby]="formControlName"
    [attr.aria-valuenow]="stringValue"
    [attr.aria-valuemin]="min"
    [attr.aria-valuemax]="max"
    autocomplete="off"
    [maxLength]="calculatedMaxLength"
    (blur)="onBlurEvent($event)"
  />
  <span id="input-suffix" #suffix [ngClass]="{ hidden: stringValue === null || stringValue === undefined }" (click)="focusInput()">{{ unitValue }}</span>
</div>
